module.exports = __webpack_public_path__ + "static/IMG_5268-e85f98d7f0f1bf8215eafb70031a938e.jpg";